import { SubscriptionStateSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * tenants/{tid}/subscription/current — the subscription state doc
 * written by tenantBootstrap and managed by the billing lifecycle Functions.
 *
 * `subscriptionRepoFor(tid).get('current')` returns the live state including
 * `status`, `nextBillingDate`, `trialEndsAt`, `outletCount`, `paymentMethod`.
 */
export function subscriptionRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/subscription`,
    schema: SubscriptionStateSchema,
    name: `tenants/${tenantId}/subscription`,
  });
}
